import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useUnitWorkloadDetails = (unitWorkloadId: number, year: number, schoolId: number) => {
  return trpc.unit.getUnitWorkloadDetails.useQuery(
    { unitWorkloadId, year, schoolId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!unitWorkloadId && !!year && !!schoolId,
    },
  );
};
